import { SecuritySettings } from '@/components/auth/SecuritySettings';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ShieldCheck } from 'lucide-react';

export function SecurityTab() {
  return (
    <Card className="overflow-hidden rounded-3xl border border-border bg-card shadow-glass">
      <CardHeader className="border-b bg-muted/30 p-8">
        <CardTitle className="flex items-center gap-3 text-foreground font-black uppercase tracking-tight">
          <ShieldCheck className="h-5 w-5" />Security Controls
        </CardTitle>
        <CardDescription className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
          Manage two-factor authentication and sign-in protections.
        </CardDescription>
      </CardHeader>
      <CardContent className="p-6 sm:p-8">
        <SecuritySettings />
      </CardContent>
    </Card>
  );
}
